import { Mail } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { PageHeader } from "@/components/kit";
import { usePageMeta } from "@/hooks/usePageMeta";

const QA = [
  ["How fast will I get a response?", "We typically reply within 24–48 hours on weekdays."],
  ["I found a bug. How do I report it?", "Email us with what you were doing, what you expected, and a screenshot if you can."],
  ["Can I request a feature?", "Absolutely — most of Mindful Me was shaped by user requests. Send us your idea."],
  ["How do I get a refund?", "Email us within 14 days of purchase with the email you signed up with and we'll take care of it."],
];

const Body = () => (
  <div className="max-w-3xl">
    <PageHeader title="Get in touch" subtitle="We read every message. If you're in crisis, please call or text 988." testId="contact-header" />
    <div className="mm-card p-8 mm-gradient-soft">
      <p className="text-mm-muted">Questions, feedback, or just want to say hi?</p>
      <a href="mailto:mindfulmeyourcalmcompanion@gmail.com" className="mm-btn mt-4" data-testid="contact-email-button">
        <Mail size={18} /> mindfulmeyourcalmcompanion@gmail.com
      </a>
    </div>
    <h2 className="text-xl font-semibold mt-10 mb-4">Common questions</h2>
    <div className="space-y-3">
      {QA.map(([q, a]) => (
        <div key={q} className="mm-card p-5">
          <div className="font-semibold">{q}</div>
          <p className="text-mm-muted text-sm mt-2">{a}</p>
        </div>
      ))}
    </div>
  </div>
);

const ContactMeta = () => {
  usePageMeta({ title: "Contact Mindful Me", description: "Questions, feedback or a refund request? Email the Mindful Me team and we'll get back to you.", path: "/contact-us" });
  return null;
};

export default function Contact({ standalone }) {
  if (!standalone) return <Body />;
  return (
    <PublicLayout>
      <ContactMeta />
      <div className="max-w-3xl mx-auto px-5 pt-14"><Body /></div>
    </PublicLayout>
  );
}
